<template>
  <Card class="page-organization">
    <div style="display: flex; margin-bottom: 15px">
      <div style="flex: 1;display: flex">
        <el-input v-model="keywords" placeholder="请输入机构名称/编码" style="max-width: 350px" @keyup.enter.native="getQueryList"/>
        <el-button type="primary" round style="margin-left: 30px" @click="getQueryList">搜索</el-button>
      </div>
      <!-- <el-button
        type="primary"
        round
        style="margin-left: 230px"
        @click="add"
      >新增机构</el-button> -->
    </div>
    <Table :columns="columns" :data="dataSource" :loading="loading">
      <template slot-scope="{ row }" slot="action">
        <el-button type="text" style="margin-right: 10px" @click="edit(row)">编辑</el-button>
        <el-popconfirm title="确定删除该机构吗？" @confirm="remove(row)">
          <el-button slot="reference" type="text" class="error">删除</el-button>
        </el-popconfirm>
        <el-button type="text" style="margin-left: 10px" @click="addItem(row)">新增</el-button>
      </template>
    </Table>
    <Modal v-model="show" :mask-closable="false" width="550" @on-cancel="cancel">
      <div slot="header" style="text-align: center">
        <span>{{cur.id ? '编辑机构' : '新增机构'}}</span>
      </div>
      <Form
        ref="form"
        :model="cur"
        :label-width="150"
        :rules="rule"
        label-position="right"
        style="margin-left: -40px;margin-right: 40px"
      >
        <FormItem label="机构名称" prop="name">
          <Input
            v-model.trim="cur.name"
            :disabled="read"
            :maxlength="30"
            placeholder="请填写机构名称"
          ></Input>
        </FormItem>
        <FormItem label="机构编码" prop="code">
          <Input
            v-model.trim="cur.code"
            :disabled="read"
            :maxlength="30"
            placeholder="请填写机构编码"
          ></Input>
        </FormItem>
        <FormItem label="地址" prop="address">
          <Input
            v-model.trim="cur.address"
            :disabled="read"
            :maxlength="100"
            placeholder="请填写机构地址"
          ></Input>
        </FormItem>
        <FormItem label="机构类型" required>
          <Select v-model="cur.type">
            <Option :value="0" key="0">上级机构</Option>
            <Option :value="1" key="1">社区机构</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button v-if="!read" type="info" round @click="cancel">取消</el-button>
        <el-button
          v-if="!read"
          type="primary"
          round
          :loading="modalLoading"
          @click="save"
          >保存</el-button>
      </div>
    </Modal>
  </Card>
</template>
<script>
import { getOrganizationListApi, updateOrganizationApi, deleteOrganizationApi } from "../../api/manage";
import caringItemTable from "../../components/caring-item-table";
export default {
  data() {
    return {
      keywords: "",
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(caringItemTable, {
              props: {
                dataSource: params.row.child_list,
                columns: this.itemColumns,
              },
            });
          },
        },
        {
          title: "ID",
          align: "center",
          key: "id",
        },
        {
          title: "机构名称",
          align: "center",
          key: "name",
        },
        {
          title: "机构编码",
          align: "center",
          key: "code",
        },
        {
          title: "地点",
          align: "center",
          key: "address",
        },
        {
          title: "机构类型",
          key: "type",
          render: (h, props) => {
            return h('span', props.row.type == 0 ? '上级机构' : '社区机构')
          },
          align: "center",
        },
        {
          title: "创建时间",
          align: "center",
          key: "create_time",
          width: 120,
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
          width: 220,
        },
      ],
      itemColumns: [
        {
          title: "ID",
          align: "center",
          key: "id",
        },
        {
          title: "机构名称",
          align: "center",
          key: "name",
        },
        {
          align: "center",
          title: "机构编码",
          key: "code",
        },
        {
          align: "center",
          title: "地点",
          key: "address",
        },
        {
          title: "机构类型",
          align: "center",
          key: "type",
          render: (h, props) => {
            return h('span', props.row.type == 0 ? '上级机构' : '社区机构')
          }
        },
        {
          title: "创建时间",
          key: "create_time",
          align: "center",
          width: 120,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          prop: "action",
          width: 220,
          slot: "action",
          render: (h, props) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                  },
                  style: {
                    marginRight: "10px",
                  },
                  on: {
                    click: () => {
                      this.edit(props.row);
                    },
                  },
                },
                "编辑"
              ),
              h("el-popconfirm", {
                props: {
                  title: "确定删除这项机构吗？",
                  placement: "top",
                },
                scopedSlots: {
                  reference: () => {
                    return h(
                      "el-button",
                      {
                        props: {
                          type: "text",
                        },
                        class: "error",
                      },
                      "删除"
                    );
                  },
                },
                on: {
                  confirm: () => {
                    this.remove(props.row);
                  },
                },
              }),
            ]);
          },
        },
      ],
      dataSource: [],
      cur: {
      },
      rule: {
        name: [
          {
            required: true,
            message: "请填写机构名称",
            trigger: "blur",
          },
          {
            required: true,
            message: "请填写机构名称",
            trigger: "change",
          },
          {
            pattern: /^[\u4e00-\u9fa5_()（）a-zA-Z0-9]+$/,
            message: "请输入由中英文、数字、括号以及下划线组成的机构名称", trigger: "blur"
          },
          {
            pattern: /^[\u4e00-\u9fa5_()（）a-zA-Z0-9]+$/,
            message: "请输入由中英文、数字、括号以及下划线组成的机构名称", trigger: "change"
          }
        ],
        code: [
          {
            required: true,
            message: "请填写机构编码",
            trigger: "blur",
          },
          {
            required: true,
            message: "请填写机构编码",
            trigger: "change",
          },
          {
            pattern: /^\w+$/,
            message: "请输入由数字、字母以及下划线组成的机构编码",
            trigger: "blur",
          },
          {
            pattern: /^\w+$/,
            message: "请输入由数字、字母以及下划线组成的机构编码",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请填写机构地址",
            trigger: "blur",
          },
          {
            required: true,
            message: "请填写机构地址",
            trigger: "change",
          },
        ],
      },
      read: false,
      loading: false,
      show: false,
      modalLoading: false,
      page: 1,
      size: 999
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getQueryList() {
      this.page = 1;
      this.getList();
    },
    getList() {
      const { page, size, keywords } = this;
      getOrganizationListApi({ page, size, keywords }).then(res => {
        if (res.code === 0) {
          this.dataSource = res.data;
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    showModal() {
      this.show = true;
    },
    hideModal() {
      this.show = false;
    },
    add() {
      this.cur = {
        name: "",
        code: "",
        type: 0,
        address: ""
      };
      this.showModal();
    },
    addItem(row) {
      this.cur = {
        pid: row.id,
        name: "",
        code: "",
        type: 0,
        address: ""
      };
      this.showModal();
    },
    edit(row) {
      this.cur = JSON.parse(JSON.stringify(row));
      this.showModal();
    },
    remove(row) {
      deleteOrganizationApi(row.id).then(res => {
        if (res.code === 0) {
          this.$Message.success("删除成功");
          this.getList();
        } else {
          this.$Message.error(res.message)
        }
      });
    },
    cancel() {
      this.$refs.form.resetFields();
      this.show = false;
      this.modalLoading = false;
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.modalLoading = true;
          updateOrganizationApi(this.cur).then(res => {
            this.modalLoading = false;
            if (res.code === 0) {
              this.hideModal();
              this.getList();
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="less">
.page-organization {
  .ivu-table-expanded-cell {
    background: #fff;
  }
    .error {
    color: #f56c6c;
    &:focus,
    &:hover {
      color: #f78989;
    }
  }
}
</style>
